<template>
	<div class="chat-rooms-container">
		<div class="chat-rooms-bar">
			<div 
				v-for="room in chatRooms" 
				:key="room.id"
				class="chat-room-compact"
				:class="{ active: expandedRoomId.includes(room.id) }"
				v-show="!expandedRoomId.includes(room.id)"
				@click="toggleRoom(room.id)"
			>
				<v-avatar size="20" color="#FF120B" class="flex-shrink-0">
					<img :src="room.morphable?.profile?.avatar" class="user-avatar" v-if="room.morphable?.profile?.avatar"/>
					<span v-else class="white--text font-weight-bold" style="font-size: 12px;">{{ roomName(room).charAt(0).toUpperCase() }}</span>
				</v-avatar>
				<div class="chat-room-info">
					<p class="chat-room-name">{{ roomName(room) }} {{ room.count }}</p>
				</div>
				<div v-if="unseenMessageCounts[room.id] > 0" class="custom-badge-counter-chat">
					<p class="mb-0 white--text" :style="{ fontSize: unseenMessageCounts[room.id] > 10 ? '10px' : '12px' }">{{ unseenMessageCounts[room.id] > 99 ? '+99' : unseenMessageCounts[room.id] }}</p>
				</div>
				<v-btn icon small @click="closeRoom(room.id)" class="flex-shrink-0">
					<v-icon small>mdi-close</v-icon>
				</v-btn>
			</div>
		</div>

		<!-- Salas expandidas -->
		<div 
			v-for="room in chatRooms" 
			:key="`expanded-${room.id}`"
			v-show="expandedRoomId.includes(room.id)"
			class="chat-window"
		>
			<MessagesFullViewMini
				:selectedChatRoomId="room.id"
				:room="room"
				:isExpanded="expandedRoomId.includes(room.id)"
				@minimize="minimizeRoom(room.id)"
				@expand="expandRoom(room.id)"
				@close="closeRoom(room.id)"
				@onRoomInfo="handleRoomInfo"
				@unseenMessageCount="onUnseenMessageCount"
			/>
		</div>
	</div>
</template>

<script>
import MessagesFullViewMini from '@/components/Views/Chat/MessagesFullViewMini'

export default {
	name: 'ChatRoomCenter',
	components: { MessagesFullViewMini },
	data: () => ({
		expandedRoomId: [],
		unseenMessageCounts: {}
	}),
	computed: {
		chatRooms() {
			return this.$store.state.general.chatRoomCenter || []
		}
	},
	watch: {
		chatRooms(newRooms, oldRooms) {
			const newRoomIds = newRooms.map(r => r.id)
			const oldRoomIds = oldRooms.map(r => r.id)
			const addedRoomIds = newRoomIds.filter(id => !oldRoomIds.includes(id))
			addedRoomIds.forEach(id => {
				if (!this.expandedRoomId.includes(id)) {
					this.expandedRoomId.push(id)
				}
			})
		}
	},
	methods: {
		toggleRoom(roomId) {
			const index = this.expandedRoomId.indexOf(roomId)
			if (index > -1) {
				this.expandedRoomId.splice(index, 1)
			} else {
				this.expandedRoomId.push(roomId)
			}
		},
		minimizeRoom(roomId) {
			const index = this.expandedRoomId.indexOf(roomId)
			if (index > -1) {
				this.expandedRoomId.splice(index, 1)
			}
		},
		expandRoom(roomId) {
			if (!this.expandedRoomId.includes(roomId)) {
				this.expandedRoomId.push(roomId)
			}
		},
		closeRoom(roomId) {
			this.$store.commit('general/removeChatRoomCenter', roomId)
		},
		handleRoomInfo(roomInfo) {
			this.$store.commit('general/updateChatRoomInfo', {
				roomId: roomInfo.id,
				roomInfo: roomInfo
			})
		},
		roomName(room_info){
			if(!room_info) return 'Chat'
			const project_line_number = room_info.morphable?.number

			if(room_info.name){
				return `${project_line_number ? 'LP' + project_line_number + ' - ' : ''}${room_info.name}`
			}
			if(room_info.morphable_type == "App\\Models\\User"){
				return room_info.morphable.profile?.name + ' ' + room_info.morphable.profile?.lastname + ' ' + room_info.morphable.profile?.second_lastname
			}
			const project_name = room_info.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.name || item.morphable.info?.project_details;
			}, null)
			return `${project_name} [LP${project_line_number}]`
		},
		onUnseenMessageCount(count, room_id) {
			this.$set(this.unseenMessageCounts, room_id, count)
		}
	}
}
</script>

<style scoped>
.chat-rooms-container {
	position: fixed;
	bottom: 0;
	right: 20px;
	z-index: 1000;
	display: flex;
	gap: 10px;
}

.chat-rooms-bar {
	display: flex;
	gap: 8px;
	align-items: flex-end;
	padding: 5px 0;
}

.chat-room-compact {
	display: flex;
	align-items: center;
	background: white;
	border-radius: 8px;
	padding: 2px 10px;
	cursor: pointer;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	transition: all 0.2s ease;
	min-width: auto;
	border: 1px solid #E0E0E0;
	gap: 8px;
}

.chat-room-compact:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	transform: translateY(-2px);
}

.chat-room-compact.active {
	background: #f0f0f0;
	border-color: #3EBFA3;
}

.chat-room-avatar {
	position: relative;
	margin-right: 12px;
	flex-shrink: 0;
}

.unread-badge {
	position: absolute;
	top: -6px;
	right: -6px;
	background: #FF1209;
	color: white;
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: bold;
}

.chat-room-info {
	flex-grow: 1;
	min-width: 0;
}

.chat-room-name {
	margin: 0;
	font-weight: 600;
	color: #050505;
	font-size: 12px;
	white-space: nowrap;
}

.chat-window {
	width: 350px;
	height: 450px;
	background: white;
	border-radius: 8px;
	box-shadow: 0 5px 40px rgba(0, 0, 0, 0.16);
	display: flex;
	flex-direction: column;
	animation: slideUp 0.3s ease;
	z-index: 1001;
}

.chat-window:nth-of-type(1) {
	right: 20px;
}
.chat-window:nth-of-type(2) {
	right: 380px;
}
.chat-window:nth-of-type(3) {
	right: 690px;
}
.chat-window:nth-of-type(4) {
	right: 1000px;
}
.chat-window:nth-of-type(5) {
	right: 1310px;
}

@keyframes slideUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.chat-window-header {
	background: linear-gradient(135deg, #3EBFA3 0%, #2fa082 100%);
	color: white;
	padding: 8px 12px;
	border-radius: 8px 8px 0 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;
	gap: 8px;
}

.header-info {
	min-width: 0;
	overflow: hidden;
}

.chat-window-header p {
	color: white;
}

.chat-window-header .v-btn {
	color: white !important;
}

.chat-content-wrapper {
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.message-group {
	display: flex;
	align-items: flex-end;
	gap: 8px;
	animation: fadeIn 0.3s ease;
}

.message-group.own {
	justify-content: flex-end;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.message-bubble {
	max-width: 70%;
	background: #E4F1FF;
	padding: 8px 12px;
	border-radius: 12px;
	word-wrap: break-word;
}

.message-group.own .message-bubble {
	background: #3EBFA3;
	color: white;
}

.message-sender {
	margin: 0;
	font-size: 11px;
	font-weight: 600;
	color: #65676b;
	margin-bottom: 4px;
}

.message-group.own .message-sender {
	color: rgba(255, 255, 255, 0.7);
}

.message-text {
	margin: 0;
	font-size: 13px;
	line-height: 1.4;
	color: #050505;
}

.message-group.own .message-text {
	color: white;
}

.message-time {
	margin: 4px 0 0 0;
	font-size: 11px;
	color: #999;
}

.message-group.own .message-time {
	color: rgba(255, 255, 255, 0.6);
}
.custom-badge-counter-chat{
	background-color: #FF120B;
	z-index: 100;
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>